import React from 'react'

export default function Divisor() {
  return <div className="menu-opcoes-divisora campo-select-divisor-cor-1" />
}
